module.exports = __webpack_public_path__ + "media/src/img/fond-cloud-a2a5889b151339a9a274ad0d1c1fa1ab.png";